import { Injectable } from '@angular/core';
import { BaseResolver } from '@app/app.resolver';
import { ModelFactory } from '@app/models/core/model-factory';
import { TrainingProgramRecord } from '@models/training/training-program-record.model';
import { TrainingProgram } from '@models/training/training-program.model';

@Injectable()
export class TrainingResolver extends BaseResolver {
    protected modelFactory: ModelFactory = new ModelFactory([
        {
            className: 'trainingProgramRecord',
            production: {
                find: (id: number) => {
                    return TrainingProgramRecord.with([
                        'trainingProgram',
                        'trainingProgram.files',
                        'employee',
                        'employee.department',
                        'trainingProgramRecordFiles',
                        'trainingProgramRecordFiles.file',
                    ]).find(id);
                },
            },
        },
        {
            className: 'trainingProgram',
            production: {
                find: (id: number) => {
                    return TrainingProgram.with(['files']).find(id);
                },
            },
        },
    ]);
}
